import React from 'react';

import { useIntl } from 'react-intl';

import Button from '@atlaskit/button/new';
import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import messages from '../messages';

const styles = cssMap({
	footer: {
		paddingTop: token('space.150'),
		paddingRight: token('space.150'),
		paddingBottom: token('space.150'),
		paddingLeft: token('space.150'),
		borderTopWidth: token('border.width'),
		borderTopStyle: 'solid',
		borderTopColor: token('color.border'),
	},
});

type CardFooterProps = {
	onConfirm: () => Promise<void>;
	isDisabled: boolean;
	isSubmitting: boolean;
};

export const CardFooter = ({
	onConfirm,
	isDisabled,
	isSubmitting,
}: CardFooterProps): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={styles.footer}>
			<Button appearance="primary" onClick={onConfirm} isDisabled={isDisabled}>
				{formatMessage(isSubmitting ? messages.buildingButtonLabel : messages.buildButtonLabel)}
			</Button>
		</Box>
	);
};
